<app-headnav [user]="reportInfo" (info)="onInfo($event)" [logOutFlag]="logOutFlag" (getLogo)="onSavedLogo($event)">
</app-headnav>
<div *ngIf="!userId" class="studio">
</div>
<div id="overlay" style="background: black url('/assets/images/loader.gif') center center no-repeat;"></div>
<div *ngIf="userId" class="studio">
    <div class="sidenav flex-container">
        <a href="#" title="Dashboard" class="active">
            <span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px"></span>
        </a>
        <a href="cover" title="Cover Page" target=_blank>
            <i class="icon-Cover" style="font-size:32px"></i>
        </a>
        <a href="template" title="Template" target=_blank>
            <i class="icon-Template" style="font-size:32px"></i>
        </a>
    </div>
    <div class="main" #main>
        <div class="row container-fluid p-0 m-0" style="height:100%; overflow:auto">
            <div class="col-md-3 contentContainer" style="width:95%;">
                <ul class="nav nav-tabs" >
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#photos" title="Photo Gallery">Photo
                            Gallery</a>
                    </li>
                </ul>
                <!-- Tab panes -->
                <div class="tab-content" style="width:95%;">
                    <div id="photos" class="container tab-pane active" style="padding:0; color:white">
                        <div class="row" style="width:98%;padding: 4px 0;">
                            <div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='PHOTO'" class="progress-wrapper col-md-10" style="height:10px;margin:4px;">
                                <div class="progress">
                                    <div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
                                        {{uploadFiles}} of {{uploadNo}}
                                    </div>
                                </div>
                            </div>
                            <span style="font-size:12px; color:#fff; margin:4px 0 0 1.5rem;"><input type="checkbox" (change)="addAllPhotos($event)"> Check/Uncheck All</span>
                            <a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" style="font-size:12px; color:#fff; border-color: #fff;" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("PHOTO")'>Upload</a>
                            <span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
                            <div style="margin-left: 1.5rem;">
                                <label class="toolLabel mr-2">Sort By</label>
                                <select  class="savedPage  col-md-5" style="width:300px" [(ngModel)]='sortingType' (change)="getSorted($event)">
                                    <option></option>
                                    <option value="Photo Description" [selected]="sortingType=='Photo Description'">Photo Description</option>
                                    <option value="Upload Date" [selected]="sortingType=='Upload Date'">Upload Date</option>
                                </select>
                                
                            </div> 
                        </div>
                       <hr class="line1 mt-0  col-md-11">
                        <ul class="widget-item-list">
                            <ng-container *ngFor="let photo of photos; let i=index">
                            <li *ngIf='photo.checked' class="item">
                                <div class="img-wrapper">
                                    <a href="javascript:void(0)" (click)="open(i)"><img *ngIf="photo.FILE_TN_URL" [src]="photo.FILE_TN_URL" class="img img-fluid" /></a>
                                </div>
                                <div *ngIf="photo.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description" (click)="openEdit(i)">
                                    {{photo.FILE_DESCRIPTION.substring(0, 17)}}<span *ngIf="photo.FILE_DESCRIPTION.length>40"> . . . </span></div>
                                <div *ngIf="photo.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description" (click)="openEdit(i)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
                                <hr class="line">
                                <input type="checkbox" (change)="addPhoto($event, i)" [(ngModel)]="photo.checked">
                                <app-edit-input [id]="'photoeditor'+i.toString()" class="float-md-right" [text]="photo.FILE_DESCRIPTION" [isphoto]="'Y'"  (edited)="updateFile(photo, 'PHOTO', $event,i)" (tonext)="updateFile(photo, 'PHOTO', $event, i, 'Next')"></app-edit-input>
                                <!--<a href="javascript:void(0);" class="remove" (click)="op44.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>-->
                                <a href="javascript:void(0);" class="remove" (click)="deleteFile(photo, 'PHOTO')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
                                <a href="javascript:void(0);" class="remove" (click)="rotateImage(photo, i)"><i class="fas fa-sync-alt" style="font-size: 10px;"></i></a>
                                <a href="javascript:void(0);" class="remove" (click)="applyto(photo)" title="Apply Change to Current Photolog"><i class="far fa-hand-point-right" style="font-size: 10px;"></i></a>
                                <!--<p-overlayPanel #op44 [appendTo]="main" [dismissable]="true" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                                    <ng-template pTemplate>
                                        <div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em">
                                            <strong>File Description : </strong><br>
                                            <textarea class="col-md-12" rows=6 maxlength="200" style="font-size:11px">{{photo.FILE_DESCRIPTION}}</textarea>
                                            <button class="btn m-0 uploadBtn float-right" (click)="updateFile(photo, 'PHOTO', $event)">Update</button>
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>-->
                                
                            </li>
                        </ng-container>
                        </ul>
                        <hr class="line1 col-md-11">
                        <ul class="widget-item-list">
                            <ng-container *ngFor="let photo of photos; let i=index">
                            <li *ngIf='!photo.checked' class="item" >
                                <div class="img-wrapper">
                                    <a href="javascript:void(0)" (click)="open(i)"><img *ngIf="photo.FILE_TN_URL" [src]="photo.FILE_TN_URL" class="img img-fluid" /></a>
                                </div>
                                <div *ngIf="photo.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description" (click)="openEdit(i)">
                                    {{photo.FILE_DESCRIPTION.substring(0, 17)}}<span *ngIf="photo.FILE_DESCRIPTION.length>40"> . . . </span></div>
                                <div *ngIf="photo.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description" (click)="openEdit(i)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
                                <hr class="line">
                                <input type="checkbox" (change)="addPhoto($event, i)" [(ngModel)]="photo.checked">
                                <app-edit-input [id]="'photoeditor'+i.toString()" class="float-md-right" [text]="photo.FILE_DESCRIPTION" [isphoto]="'Y'"  (edited)="updateFile(photo, 'PHOTO', $event,i)" (tonext)="updateFile(photo, 'PHOTO', $event, i, 'Next')"></app-edit-input>
                                <!--<a href="javascript:void(0);" class="remove" (click)="op44.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>-->
                                <a href="javascript:void(0);" class="remove" (click)="deleteFile(photo, 'PHOTO')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
                                <a href="javascript:void(0);" class="remove" (click)="rotateImage(photo, i)"><i class="fas fa-sync-alt" style="font-size: 10px;"></i></a>
                                <!--<p-overlayPanel #op44 [appendTo]="main" [dismissable]="true" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                                    <ng-template pTemplate>
                                        <div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em">
                                            <strong>File Description : </strong><br>
                                            <textarea class="col-md-12" rows=6 maxlength="200" style="font-size:11px">{{photo.FILE_DESCRIPTION}}</textarea>
                                            <button class="btn m-0 uploadBtn float-right" (click)="updateFile(photo, 'PHOTO', $event)">Update</button>
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>-->
                                
                            </li>
                        </ng-container>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-7 editContainer">
                <div *ngIf="!usingtpl" class="tool sticky-top row">
                    <button class="btn btn-dark btn-sm mr-1" title="Portrait" [ngStyle]="{'border':selectpage.type==='portrait'? '1px solid yellow':'none'}" (click)="selectPage('portrait')"><i class="fas fa-arrows-alt-v"></i>
                    </button>
                    <button class="btn btn-dark btn-sm mr-1" title="Landscape" [ngStyle]="{'border':selectpage.type==='landscape'? '1px solid yellow':'none'}" (click)="selectPage('landscape')"><i class="fas fa-arrows-alt-h"></i>
                    </button>
                    <button class="btn btn-dark btn-sm mr-1" title="Margin" data-target='#marginModal' data-toggle="modal"><i class="fas fa-arrows-alt"></i>
                    </button>
                    <input type="checkbox" [(ngModel)]="showNo" (change)="saveNoConfig()"><label class="toolLabel">Print Photo Numbers</label>
                </div>
                <div class="pageContainer">
                    <div class="example-list" #viewer [style.width.px]="selectpage.size.width" [style.min-height.px]="selectpage.size.height">
                        <div *ngIf="!usingtpl" [style.padding-top.px]="pageMargin.top" [style.padding-bottom.px]="pageMargin.bottom" [style.padding-left.px]="pageMargin.left" [style.padding-right.px]="pageMargin.right">
                            <div class="gallery-block cards-gallery {{selectpage.type}}">
                                <div class="row {{selectedTemplate}}">
                                    <div class="col" *ngFor="let photo of photoLog; let i=index">
                                        <div class="card">
                                            <img *ngIf="photo.FILE_URL" [src]="photo.FILE_URL" class="card-img-top" style="object-fit: contain"/> <!--'object-fit' is css to keep image ratio-->
                                            <div class="card-body">
                                                <div class="card-number">
                                                    
                                                    <input type="checkbox" (click)="deletePhoto(i)" checked="checked">
                                                </div>
                                                <div class="card-text" title="{{photo.FILE_DESCRIPTION}}">
                                                    <span *ngIf="showNo" style="margin-right: 4px;">#{{i+1}}</span>  {{photo.FILE_DESCRIPTION}}
                                                </div>
                                                <div>
                                                    <app-edit-input [id]="'editor'+i.toString()" class="float-md-right" [text]="photo.FILE_DESCRIPTION" [isphoto]="'Y'" (edited)="addLib=false; setPhotoDesc($event,i)" (tonext)="addLib=false; setPhotoDesc($event,i, 'next')"></app-edit-input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="usingtpl">
                            <ng-container [ngSwitch]="tpl">
                                <app-template-k *ngSwitchCase="'k'" [photos]="photoLog" [photoslength]="photoLog.length"></app-template-k>
                                <app-template-l *ngSwitchCase="'l'" [photos]="photoLog" [photoslength]="photoLog.length"></app-template-l>
                                <app-template-q *ngSwitchCase="'q'" [photos]="photoLog" [photoslength]="photoLog.length" [showDateDirectionLocation]="showDateDirectionLocationChecked"></app-template-q>
                                <app-template-r *ngSwitchCase="'r'" [photos]="photoLog" [photoslength]="photoLog.length" [showDateDirectionLocation]="showDateDirectionLocationChecked"></app-template-r>
                                <app-template-s *ngSwitchCase="'s'" [photos]="photoLog" [photoslength]="photoLog.length"></app-template-s>
                                <app-template-t *ngSwitchCase="'t'" [photos]="photoLog" [photoslength]="photoLog.length"></app-template-t>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-2 toolContainer">
                <!-- Nav tabs -->
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#home">Tools</a>
                    </li>
                </ul>
                <!-- Tab panes -->
                <div class="tab-content">
                    <div id="home" class="container tab-pane active"><br>
                        <div class="toolGroup">
                            <div class="row mt-2 mb-3">
                                <button class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn" data-target='#sortModal' data-toggle="modal" title="Sort Photos" (click) ="initPhotoTable()" >Sort Photos</button>
                                <button class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn" title="Save Photo Log" (click)='preview(true)'>Save Photo Log</button>
                            </div>
                            <input #file type="file" style="display: none;" multiple (change)="uploadImage()" accept='.png,.PNG,.jpg,.JPG, .jpeg,.JPEG' />
                            <hr class="col-md-12 line">

                            <input type="radio"
                                id="notusingtpl"
                                name="usingtpl"
                                [value]="false"
                                [(ngModel)]="usingtpl"/>
                            <label class="m-2" for="notusingtpl">Build Your Own</label>
                            <br>
                            <label class="savedLabel col-md-5">Template</label>
                            <select class="savedPage col-md-6" [(ngModel)]="selectedTemplate"
                                (change)="usingtpl=false;">
                                <option value="gallery-6">2x3 Photos per Page</option>
                                <option value="gallery-4">2x2 Photos per Page</option>
                                <option value="gallery-2">2x1 Photos per Page</option>
                                <option value=""></option>
                            </select>

                            <label class="savedLabel col-md-5">Header</label>
                            <select class="savedPage col-md-6" [(ngModel)]="selectedHeader" (change)="saveHeader()">
                                <option></option>
                                <option *ngFor="let header of headers" [value]="header.HEADERFOOTER_ID">
                                    {{header.HF_TITLE}}</option>
                            </select>
                            <label class="savedLabel col-md-5">Footer</label>
                            <select class="savedPage col-md-6" [(ngModel)]="selectedFooter" (change)="saveFooter()">
                                <option></option>
                                <option *ngFor="let footer of footers" [value]="footer.HEADERFOOTER_ID">
                                    {{footer.HF_TITLE}}</option>
                            </select>
                            <br>

                            <!-- <hr class="col-md-12 line">
                            <input type="checkbox" [(ngModel)]="sortThumbnail">
                            <label class="savedLabel col-md-10">Sort Thumbnail</label> -->

                            <input type="radio"
                                id="yesusingtpl"
                                name="usingtpl"
                                [value]="true"
                                [(ngModel)]="usingtpl"/>
                            <label class="m-2" for="yesusingtpl">Use Out-of-Box Template</label>
                            <br>
                            <div class="row">
                                <button class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn" title="Out-of-Box Templates"
                                    (click)="opOutofBoxTemplates.toggle($event);">
                                    Out-of-Box Templates</button>
                                <span class="m-1">{{tplnames[tpl]}}</span>
                                <a class="m-1" href="javascript:void(0);" (click)="pickTpl(tpl, tplnames[tpl]);"><i class="far fa-edit"></i></a>
                            </div>
                            <p-overlayPanel #opOutofBoxTemplates [appendTo]="'body'"
                                [style]="{'width': '300px'}">
                                <ng-template pTemplate>
                                    <div *ngFor="let row of [0, 2, 4]">
                                        <div class="d-flex flex-row w-100">
                                            <div *ngFor="let t of tpls |slice: row:row+2; let i = index">
                                                <div class="tpl" style="flex-basis: 50%;" [class.selected]="tpl===t">
                                                    <div class="tpl-hover">
                                                        <a href="javascript:void(0);" (click)="pickTpl(t, 'Photo' + (row+i+1))">
                                                            {{tpl === t ? 'Edit template' : 'Use template'}}
                                                        </a>
                                                    </div>
                                                    <div *ngIf="tpl===t" class="tpl-check">
                                                        <i class="fa fa-check"></i>
                                                    </div>
                                                    <img [src]="'../../assets/images/p' + t + '.jpg'" class="img img-thumbnail" [alt]="'template ' + t">
                                                    <figcaption style="color:white">Photo {{row+i+1}}</figcaption>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </p-overlayPanel>
                            <hr class="col-md-12 line">
                            <app-reportinfo [user]="reportInfo" (info)="onInfo($event)" (getLogo)="onSavedLogo($event)">
                            </app-reportinfo>
                            <a *ngIf="photologurl" href="javascript:void(0)" (click)="getPhotolog()" class="mb-2 mt-2" style="margin-left: 10px;">Access Photo Log PDF</a>
                            <hr class="col-md-12 line">
                            <!--<div class="gallery-block cards-gallery {{selectpage.type}}" cdkDropListGroup>
                                <div class="gallery-s" fxLayout="column" *ngFor="let photoRow of photoTable; let i=index; let last=last"
                                    cdkDropList cdkDropListOrientation="vertical" [cdkDropListData]="photoRow" (cdkDropListDropped)="dropPhoto($event)">
                                    <div class="col" *ngFor="let photo of photoRow; let j=index" cdkDrag>
                                        <div class="card">
                                            <img *ngIf="photo.FILE_URL" [src]="photo.FILE_URL" class="card-img-top" style="object-fit: contain"/>
                                            <div class="card-body">
                                                <div class="card-number">
                                                    <span>#{{i*4+j+1}}</span>
                                                </div>
                                                <div class="card-text">
                                                    {{photo.FILE_DESCRIPTION}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="last">
                                        <div *ngFor="let e of [].constructor((photoTableColumns-photoLog.length%photoTableColumns)%photoTableColumns)" class="col" aria-hidden="true"></div>
                                    </ng-container>
                                </div>
                            </div>-->

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-panel [header]="'Profile Management'" [opened]="showLogo" [align]="'right'" [fixed]="[-10, 54]" (didClosed)="showLogo = null">
        <ng-container name="body">
            <app-logo *ngIf="userInfo" class="w-100 h-100" [logoInfo]="logoInfo" [userInfo]='userInfo' (editReport)="onEditReport($event)" (logOut)='logOut()'></app-logo>
        </ng-container>
    </app-panel>
</div>
<div *ngIf="!usingtpl" id="marginModal" class="modal fade" data-backdrop='false'>
    <div class="modal-dialog modal-sm modal-dialog-centered ">
        <div class="modal-content" style="background:#444; color:#ccc">
            <!-- Modal Header -->
            <div class="modal-header">
                <h6 id="" class="modal-title">Set Margin Size</h6>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <label class="col-md-7">Margin Top</label><input class="col-md-4" type='number' [(ngModel)]="pageMargin.top" />px<br>
                <label class="col-md-7">Margin Bottom</label><input class="col-md-4" type='number' [(ngModel)]="pageMargin.bottom" />px<br>
                <label class="col-md-7">Margin Left</label><input class="col-md-4" type='number' [(ngModel)]="pageMargin.left" />px<br>
                <label class="col-md-7">Margin Right</label><input class="col-md-4" type='number' [(ngModel)]="pageMargin.right" />px<br>
                <button class="btn m-0 btn-op float-right" (click)="saveMargin()">Save</button>
            </div>
        </div>
    </div>
</div>
<div style="display:none" #outContent>
    <div *ngIf="!usingtpl">
        <div class="{{selectpage.type}}">
            <div class="{{selectedTemplate}}">
                <div class="row" *ngFor="let photoRow of toPhotoTable(photoLog); let i=index">
                    <ng-container *ngFor="let photo of photoRow; let j=index">
                        <ng-template [ngIf]="photo.FILE_URL">
                            <div class="card">
                                <img *ngIf="photo.FILE_URL" [src]="photo.FILE_URL" class="card-img-top" style="object-fit: contain"/>
                                <div class="card-body">
                                    <div class="card-number"></div>
                                    <div class="text-muted"><span *ngIf="showNo" style="margin-right: 4px;">#{{i*photoRow.length+j+1}}</span> {{photo.FILE_DESCRIPTION}}</div>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template [ngIf]="!photo.FILE_URL">
                            <div class="card spacer"></div>
                        </ng-template>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="usingtpl">
        <div class="{{selectpage.type}}">
            <ng-container [ngSwitch]="tpl">
                <app-template-k *ngSwitchCase="'k'" [photos]="photoLog" [photoslength]="photoLog.length"></app-template-k>
                <app-template-l *ngSwitchCase="'l'" [photos]="photoLog" [photoslength]="photoLog.length"></app-template-l>
                <app-template-q *ngSwitchCase="'q'" [photos]="photoLog" [photoslength]="photoLog.length" [showDateDirectionLocation]="showDateDirectionLocationChecked"></app-template-q>
                <app-template-r *ngSwitchCase="'r'" [photos]="photoLog" [photoslength]="photoLog.length" [showDateDirectionLocation]="showDateDirectionLocationChecked"></app-template-r>
                <app-template-s *ngSwitchCase="'s'" [photos]="photoLog" [photoslength]="photoLog.length"></app-template-s>
                <app-template-t *ngSwitchCase="'t'" [photos]="photoLog" [photoslength]="photoLog.length"></app-template-t>
            </ng-container>
        </div>
    </div>
</div>

<!-- Templates Preview Modal: -->
<div cdkDrag #templatePreviewModal id="templatePreviewModal" class="modal fade show" style="max-height: 99vh;max-width: 99vw; overflow: visible">
    <div [ngClass]="['modal-dialog', 'modal-' + ((previewtpl == 'r'|| previewtpl == 't')? 'A4-landscape' : 'A4')]">
        <div class="modal-content">
            <div class="modal-header" style="background-color: #323232; color: rgb(222, 222, 222); border: 0px">
                <h5 class="modal-title">Edit Template</h5>
                <button type="button" class="close" data-dismiss="modal" style="color: rgb(222, 222, 222);">
                    <span>×</span>
                </button>
            </div>

            <div class="modal-body ps">
                <div class="d-flex flex-column page-A4 tc" *ngIf="previewtpl === 'k'">
                    <div style="display:flex; flex-direction: row; height:40px">
                        <div class="d-flex w-100 h-100 align-items-left justify-content-left"
                            style="cursor: pointer;flex-basis:70%; " *ngIf="!reportService.templateModel.logo">
                            <i class="fal fa-cloud-upload"></i>
                            <span class="ml-2">Upload logo</span>
                        </div>
                        <div class="d-flex w-100 h-100 align-items-left justify-content-left"
                            style="cursor: pointer;flex-basis:70%;" *ngIf="reportService.templateModel.logo">
                            <img style="max-height: 40px; max-width: 100%" [src]="reportService.templateModel.logo"
                                alt="logo" />
                        </div>
                        <div class="align-items-right" style="display:flex;flex-basis:30%; ">
                            <i class="fa fa-pen"></i>
                            <app-editable class="d-flex align-items-center" style=' flex-grow: 2'
                                [text]="reportService.templateModel.caption"
                                (edited)="reportService.templateModel.caption = $event"
                                [defaultText]="editableDefaultText"
                                (mousedown)="$event.stopPropagation()"></app-editable>
                                <!-- the mousedown function makes it not drag when selecting text -->
                        </div>
                    </div>
                    <div
                        style="border: 1px solid #202124; background-color: #fff; display: flex; flex-direction: column; justify-content: center;">
                        <div style="border: 1px solid #202124; display: flex; flex-direction: column;">
                            <div
                                style="width:100%; border-bottom: 1px solid #202124; display: flex; flex-direction: row;;">
                                <p style="display:flex; flex-grow: 1">Project Name: </p>
                                <i class="fa fa-pen"></i>
                                <app-editable class="d-flex align-items-center" style='flex-grow: 2'
                                    [text]="reportService.templateModel.description"
                                    (edited)="reportService.templateModel.description = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                                <p style="display:flex; flex-grow: 1">Project No</p>
                                <i class="fa fa-pen"></i>
                                <app-editable class="d-flex align-items-center" style=' flex-grow: 2'
                                    [text]="reportService.templateModel.pno"
                                    (edited)="reportService.templateModel.pno = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                            <div
                                style="width:100%; border-bottom: 1px solid #202124; display: flex; flex-direction: row;">
                                <p style="display:flex; flex-grow: 1">Site Location: </p>
                                <i class="fa fa-pen"></i>
                                <app-editable class="d-flex align-items-center" style='display:flex; flex-grow: 3'
                                    [text]="reportService.templateModel.addr"
                                    (edited)="reportService.templateModel.addr = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                                <p style="display:flex; flex-grow: 1"></p>
                                <p style="display:flex; flex-grow: 3"></p>
                            </div>
                            <div class="border:right"
                                style="display:flex; flex-direction: row; height:300px;border-bottom: 1px solid #202124; ">
                                <div
                                    style="display:flex; flex-direction: column; flex-basis:30%;  border-right: 1px solid #202124; ">
                                    <div style="display:flex; flex-grow: 1; border-bottom: 1px solid #202124;">
                                        <label>Photograph ID : </label>
                                    </div>
                                    <!--<div   style="display:flex; flex-grow: 1; border-bottom: 1px solid #202124;">
                                    <label>Photograph Location : </label>
                                </div>-->
                                    <!-- <div style="display:flex; flex-grow: 1; border-bottom: 1px solid #202124;">
                                        <label>Photograph Tag : </label>
                                    </div> -->
                                    <div style="display:flex; flex-grow: 1; border-bottom: 1px solid #202124;">
                                        <label>Survey Date : </label>
                                    </div>
                                    <div style="display:flex; flex-grow: 7;">
                                        <label>Comments</label>
                                    </div>
                                </div>
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%; padding:10px; margin-left: 20%;">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-0" style="min-height:280PX; width:200px;"></div>
                                </div>
                            </div>
                            <div class="border:right" style="display:flex; flex-direction: row;height:300px; ">
                                <div
                                    style="display:flex; flex-direction: column; flex-basis:30%; border-right: 1px solid #202124; ">
                                    <div style="flex-grow: 1; border-bottom: 1px solid #202124;">
                                        <label>Photograph ID : </label>
                                    </div>
                                    <!--<div style="display:flex; flex-grow: 1; border-bottom: 1px solid #202124;">
                                    <label>Photograph Location : </label>
                                </div>-->
                                    <!-- <div style="display:flex; flex-grow: 1; border-bottom: 1px solid #202124;">
                                        <label>Photograph Tag : </label>
                                    </div> -->
                                    <div style="display:flex; flex-grow: 1; border-bottom: 1px solid #202124;">
                                        <label>Survey Date : </label>
                                    </div>
                                    <div style="display:flex; flex-grow: 7">
                                        <label>Comments</label>
                                    </div>
                                </div>
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px; margin-left: 20%; ">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-0 " style="min-height:280PX; width:200px"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column page-A4 tc" *ngIf="previewtpl === 'l'">
                    <div
                        style="background-color: #fff; display: flex; flex-direction: column; justify-content: center;padding:20px 80px">
                        <div style="display: flex; flex-direction: column;">
                            <div
                                style="position: relative;display:flex; flex-direction: column; flex-basis:30%; padding:10px; ">
                                <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                    style="z-index: 10"> &lt;Auto-filled&gt;: Photo</div>
                                <div class="img-container border-1" style="min-height:260PX; width:620px"></div>
                            </div>
                            <div class="d-flex align-items-left justify-content-center"
                                style="display:flex; flex-direction: column;margin-left: 10px;">
                                <span>Photo 1</span>
                                <!--<span>Comments</span>-->
                            </div>
                            <div
                                style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                    style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                <div class="img-container border-1 " style="min-height:260PX; width:620px; "></div>
                            </div>
                            <div class="d-flex align-items-left justify-content-center"
                                style="display:flex; flex-direction: column;margin-left: 10px;">
                                <span>Photo 2</span>
                                <!--<span>Comments</span>-->
                            </div>
                        </div>
                    </div>
                    <div
                        style="display:flex; flex-direction: row; height:70px; border-top: 1px solid black; margin: 20px 80px;">
                        <div
                            style="display:flex; flex-basis:40%; flex-direction:column;cursor: pointer;font-size:.8em;">
                            <div style="display:flex">Project Name :<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.description"
                                    (edited)="reportService.templateModel.description = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                            <div style="display:flex"> Address :<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.addr"
                                    (edited)="reportService.templateModel.addr = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                            <div style="display:flex"> Project No:<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.pno"
                                    (edited)="reportService.templateModel.pno = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                        </div>
                        <div class="align-items-right" style="display:flex;flex-basis:40%;flex-direction:row; ">
                            <i class="fa fa-pen" style="font-size: .8em;"></i>
                            <app-editable style=' flex-grow: 2' [text]="reportService.templateModel.caption"
                                (edited)="reportService.templateModel.caption = $event"
                                [defaultText]="editableDefaultText"
                                (mousedown)="$event.stopPropagation()"></app-editable>
                        </div>
                        <div class="d-flex w-100 h-100 align-items-right justify-content-right"
                            style="cursor: pointer;flex-basis:20%; " *ngIf="!reportService.templateModel.logo">
                            <i class="fal fa-cloud-upload"></i>
                            <span class="ml-2">Upload Logo</span>
                        </div>
                        <div class="d-flex w-100 h-100 align-items-right justify-content-right"
                            style="cursor: pointer;flex-basis:20%;" *ngIf="reportService.templateModel.logo">
                            <img style="max-height: 70px; max-width: 100%" [src]="reportService.templateModel.logo"
                                alt="logo" />
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column page-A4 tc" *ngIf="previewtpl === 'q'">
                    <div
                        style="background-color: #fff; display: flex; flex-direction: column; justify-content: center;padding:20px 80px">
                        <div style="display: flex; flex-direction: column;">
                            <div style="display: flex; flex-direction: row;">
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%; padding:10px; ">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1" style="min-height:260PX; width:300px"></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 1</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1 " style="min-height:260PX; width:300px; "></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 2</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: row;">
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%; padding:10px; ">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1" style="min-height:260PX; width:300px"></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 3</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1 " style="min-height:260PX; width:300px; "></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 4</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style="display:flex; flex-direction: row; height:70px; border-top: 1px solid black; margin: 20px 80px;">
                        <div
                            style="display:flex; flex-basis:40%; flex-direction:column;cursor: pointer;font-size:.8em;">
                            <div style="display:flex">Project Name :<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.description"
                                    (edited)="reportService.templateModel.description = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                            <div style="display:flex"> Address :<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.addr"
                                    (edited)="reportService.templateModel.addr = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                            <div style="display:flex"> Project No:<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.pno"
                                    (edited)="reportService.templateModel.pno = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                        </div>
                        <div class="align-items-right" style="display:flex;flex-basis:40%;flex-direction:row; ">
                            <i class="fa fa-pen" style="font-size: .8em;"></i>
                            <app-editable style=' flex-grow: 2' [text]="reportService.templateModel.caption"
                                (edited)="reportService.templateModel.caption = $event"
                                [defaultText]="editableDefaultText"
                                (mousedown)="$event.stopPropagation()"></app-editable>
                        </div>
                        <div class="d-flex w-100 h-100 align-items-right justify-content-right"
                            style="cursor: pointer;flex-basis:20%; " *ngIf="!reportService.templateModel.logo">
                            <i class="fal fa-cloud-upload"></i>
                            <span class="ml-2">Upload logo</span>
                        </div>
                        <div class="d-flex w-100 h-100 align-items-right justify-content-right"
                            style="cursor: pointer;flex-basis:20%;" *ngIf="reportService.templateModel.logo">
                            <img style="max-height: 70px; max-width: 100%" [src]="reportService.templateModel.logo"
                                alt="logo" />
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column page-A4 ta" *ngIf="previewtpl === 'r'">
                    <div
                        style="background-color: #fff; display: flex; flex-direction: column; justify-content: center;padding:20px 80px">
                        <div style="display: flex; flex-direction: column;">
                            <div style="display: flex; flex-direction: row;">
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%; padding:10px; ">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1" style="min-height:260PX; width:420px"></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 1</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1 " style="min-height:260PX; width:420px; "></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 2</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: row;">
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%; padding:10px; ">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1" style="min-height:260PX; width:420px"></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 3</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1 " style="min-height:260PX; width:420px; "></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 4</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style="display:flex; flex-direction: row; height:70px; border-top: 1px solid black; margin: 20px 80px;">
                        <div
                            style="display:flex; flex-basis:40%; flex-direction:column;cursor: pointer;font-size:.8em;">
                            <div style="display:flex">Project Name :<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.description"
                                    (edited)="reportService.templateModel.description = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                            <div style="display:flex"> Address :<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.addr"
                                    (edited)="reportService.templateModel.addr = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                            <div style="display:flex"> Project No:<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.pno"
                                    (edited)="reportService.templateModel.pno = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                        </div>
                        <div class="align-items-right" style="display:flex;flex-basis:40%;flex-direction:row; ">
                            <i class="fa fa-pen" style="font-size: .8em;"></i>
                            <app-editable style=' flex-grow: 2' [text]="reportService.templateModel.caption"
                                (edited)="reportService.templateModel.caption = $event"
                                [defaultText]="editableDefaultText"
                                (mousedown)="$event.stopPropagation()"></app-editable>
                        </div>
                        <div class="d-flex w-100 h-100 align-items-right justify-content-right"
                            style="cursor: pointer;flex-basis:20%; " *ngIf="!reportService.templateModel.logo">
                            <i class="fal fa-cloud-upload"></i>
                            <span class="ml-2">Upload logo</span>
                        </div>
                        <div class="d-flex w-100 h-100 align-items-right justify-content-right"
                            style="cursor: pointer;flex-basis:20%;" *ngIf="reportService.templateModel.logo">
                            <img style="max-height: 70px; max-width: 100%" [src]="reportService.templateModel.logo"
                                alt="logo" />
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column page-A4 tc" *ngIf="previewtpl === 's'">
                    <div
                        style="background-color: #fff; display: flex; flex-direction: column; justify-content: center;padding:20px 80px">
                        <div style="display: flex; flex-direction: column;">
                            <div style="display: flex; flex-direction: row;">
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%; padding:10px; ">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1" style="min-height:170PX; width:300px"></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 1</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1 " style="min-height:170PX; width:300px; "></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 2</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: row;">
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%; padding:10px; ">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1" style="min-height:170PX; width:300px"></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 3</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1 " style="min-height:170PX; width:300px; "></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 4</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: row;">
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%; padding:10px; ">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1" style="min-height:170PX; width:300px"></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 5</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1 " style="min-height:170PX; width:300px; "></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 6</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style="display:flex; flex-direction: row; height:70px; border-top: 1px solid black; margin: 10px 80px;">
                        <div
                            style="display:flex; flex-basis:40%; flex-direction:column;cursor: pointer;font-size:.8em;">
                            <div style="display:flex">Project Name :<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.description"
                                    (edited)="reportService.templateModel.description = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                            <div style="display:flex"> Address :<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.addr"
                                    (edited)="reportService.templateModel.addr = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                            <div style="display:flex"> Project No:<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.pno"
                                    (edited)="reportService.templateModel.pno = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>

                        </div>
                        <div class="align-items-right" style="display:flex;flex-basis:40%;flex-direction:row; ">
                            <i class="fa fa-pen" style="font-size: .8em;"></i>
                            <app-editable style=' flex-grow: 2' [text]="reportService.templateModel.caption"
                                (edited)="reportService.templateModel.caption = $event"
                                [defaultText]="editableDefaultText"
                                (mousedown)="$event.stopPropagation()"></app-editable>
                        </div>
                        <div class="d-flex w-100 h-100 align-items-right justify-content-right"
                            style="cursor: pointer;flex-basis:20%; " *ngIf="!reportService.templateModel.logo">
                            <i class="fal fa-cloud-upload"></i>
                            <span class="ml-2">Upload logo</span>
                        </div>
                        <div class="d-flex w-100 h-100 align-items-right justify-content-right"
                            style="cursor: pointer;flex-basis:20%;" *ngIf="reportService.templateModel.logo">
                            <img style="max-height: 70px; max-width: 100%" [src]="reportService.templateModel.logo"
                                alt="logo" />
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column page-A4 ta" *ngIf="previewtpl === 't'">
                    <div
                        style="background-color: #fff; display: flex; flex-direction: column; justify-content: center;padding:20px 80px">
                        <div style="display: flex; flex-direction: column;">
                            <div style="display: flex; flex-direction: row;">

                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%; padding:10px; ">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1" style="min-height:220PX; width:270px"></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 1</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>

                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1 " style="min-height:220PX; width:270px; "></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 2</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1 " style="min-height:220PX; width:270px; "></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 3</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>

                            </div>
                            <div style="display: flex; flex-direction: row;">

                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%; padding:10px; ">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1" style="min-height:220PX; width:270px"></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 4</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>



                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1 " style="min-height:220PX; width:270px; "></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 5</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>
                                <div
                                    style="position: relative;display:flex; flex-direction: column; flex-basis:30%;padding:10px">
                                    <div class="position-absolute d-flex flex-1 align-items-center justify-content-center font-weight-bolder w-100 h-100"
                                        style="z-index: 10;"> &lt;Auto-filled&gt;: Photo</div>
                                    <div class="img-container border-1 " style="min-height:220PX; width:270px; "></div>
                                    <div style="margin: 10px 0;position: relative;display:flex;">
                                        <span>Photo 6</span>
                                        <!--<span>Comments</span>-->
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div
                        style="display:flex; flex-direction: row; height:70px; border-top: 1px solid black; margin: 20px 80px;">
                        <div
                            style="display:flex; flex-basis:40%; flex-direction:column;cursor: pointer;font-size:.8em;">
                            <div style="display:flex">Project Name :<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.description"
                                    (edited)="reportService.templateModel.description = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                            <div style="display:flex"> Address :<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.addr"
                                    (edited)="reportService.templateModel.addr = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>
                            <div style="display:flex"> Project No:<i class="fa fa-pen"></i>
                                <app-editable [text]="reportService.templateModel.pno"
                                    (edited)="reportService.templateModel.pno = $event"
                                    [defaultText]="editableDefaultText"
                                    (mousedown)="$event.stopPropagation()"></app-editable>
                            </div>

                        </div>
                        <div class="align-items-right" style="display:flex;flex-basis:40%;flex-direction:row; ">
                            <i class="fa fa-pen" style="font-size: .8em;"></i>
                            <app-editable style=' flex-grow: 2' [text]="reportService.templateModel.caption"
                                (edited)="reportService.templateModel.caption = $event"
                                [defaultText]="editableDefaultText"
                                (mousedown)="$event.stopPropagation()"></app-editable>
                        </div>
                        <div class="d-flex w-100 h-100 align-items-right justify-content-right"
                            style="cursor: pointer;flex-basis:20%; " *ngIf="!reportService.templateModel.logo">
                            <i class="fal fa-cloud-upload"></i>
                            <span class="ml-2">Upload logo</span>
                        </div>
                        <div class="d-flex w-100 h-100 align-items-right justify-content-right"
                            style="cursor: pointer;flex-basis:20%;" *ngIf="reportService.templateModel.logo">
                            <img style="max-height: 70px; max-width: 100%" [src]="reportService.templateModel.logo"
                                alt="logo" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer" style="background-color: #323232; color: rgb(222, 222, 222); border: 0px">
                <!-- <button type="button" class="btn btn-dark">
                    Preview
                </button> -->
                <div *ngIf="previewtpl === 'r' || previewtpl === 'q'" class="custom-control custom-checkbox mr-auto d-flex align-items-center">
                    <input type="checkbox" class="custom-control-input" id="showDateDirectionLocation" 
                            [checked]="tempShowDateDirectionLocation" 
                            (change)="onDateDirectionLocationChange($event.target.checked)">
                    <label class="custom-control-label" for="showDateDirectionLocation" style="margin-bottom: 0; line-height: 1.2; padding-top: 2.5px;">
                        Display Date, Location, and Direction on Image
                    </label>
                </div>
                <button type="button" class="btn btn-outline-dark" (click)="confirmTpl()" style="color: rgb(222, 222, 222);">
                    <!-- <span *ngIf="spinnerConfirm" class="spinner-grow spinner-grow-sm"></span> -->
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>
<div cdkDrag id="sortModal" #sortModal class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">
    <div  class="modal-dialog modal-dialog-centered" style="max-width:80vw; max-height: 90vh;overflow:auto;">
        <div class="modal-content" style="border: solid 1px #C2D63F;">
            <div class="modal-header" style="background-color: #323232; color: rgb(222, 222, 222); border: 0px">
                <h5 class="modal-title">Sort Photos</h5>
                <button type="button" class="close" data-dismiss="modal" style="color: rgb(222, 222, 222);">
                    <span>×</span>
                </button>
            </div>
            <div class="modal-body" style="background-color: #4C4C4C;height:88vh; overflow:auto;">
                <div style="margin-left: 1.5rem;">
                    <label class="toolLabel mr-2" style="font-size: 12px;">Sort By</label>
                    <select  class="savedPage" (change)="getSorted($event, 'local')">
                        <option></option>
                        <option value="FILE_DESCRIPTION">Photo Description</option>
                        <option value="DATE_UPDATED">Upload Date</option>
                    </select>
                </div>
                <div class="gallery-block cards-gallery" cdkDropListGroup>
                    <div class="row gallery-s" fxLayout="row" *ngFor="let photoRow of photoTable; let i=index; let last=last" cdkDropList cdkDropListOrientation="horizontal" [cdkDropListData]="photoRow" (cdkDropListDropped)="dropPhoto($event)">
                        <div class="col" *ngFor="let photo of photoRow; let j=index" cdkDrag>
                            <div class="card">
                                <div class="card-img1">
                                    <img *ngIf="photo.FILE_URL" [src]="photo.FILE_URL" class="card-img-top"  style="object-fit: cover;"/>
                                </div>
                                <div class="card-body">
                                    <div class="card-number">
                                        <span>#{{i*6+j+1}}</span>
                                    </div>
                                   <div class="card-text1">
                                        {{photo.FILE_DESCRIPTION}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="last">
                            <div *ngFor="let e of [].constructor((photoTableColumns-photoLog.length%photoTableColumns)%photoTableColumns)" class="col" aria-hidden="true"></div>
                        </ng-container>
                    </div>
                </div>
                <!--<div class="gallery-block cards-gallery {{selectpage.type}}" cdkDropListGroup>
                    <div class="row" cdkDropList  [cdkDropListData]="photoLog" (cdkDropListDropped)="dropPhotolog($event)">
                        <div class="cards-gallery1 gallery-s" *ngFor="let photo of photoLog; let j=index" cdkDrag [cdkDragData]="photo">
                            <div class="card">
                                <img *ngIf="photo.FILE_TN_URL" [src]="photo.FILE_TN_URL" class="card-img-top thumbnail" />
                                <div class="card-body">-->
                                    <!--<div class="card-number">
                                        <span>#{{j}}</span>
                                    </div>
                                    <div class="card-text">
                                        {{photo.FILE_DESCRIPTION}}
                                    </div>
                                </div>
                            </div>
                        </div>-->
                        <!--<ng-container *ngIf="last">
                            <div *ngFor="let e of [].constructor((photoTableColumns-photoLog.length%photoTableColumns)%photoTableColumns)" class="col" aria-hidden="true"></div>
                        </ng-container>
                    </div>
                </div>-->
			</div>
		</div>
	</div>
</div>